import { gql } from 'apollo-angular';

export const PRODUCT_LINE_DIMENSIONS_FRAGMENT = gql`
  fragment ProductLineDimensionsFragment on ProductLine {
    snkDimensions {
      door { width height thickness full direction }
      door2 { width height thickness full direction }
      frame { width height thickness full direction }
      frame2 { width height thickness full direction }
      frame3 { width height thickness full direction }
      panel { width height thickness full direction }
      direction { value element }
      zfm { width height thickness full }
      bram { width height thickness full }
      bam { width height thickness full }
      woem { width height thickness full }
      currentType { value }
    }
  }
`;
